import React, { createContext, useContext, useState, useEffect } from "react";
import AuthContext from "./AuthContext";
import { useCompany } from "./CompanyContext";
import { getNlisFeatures } from "../api/nlis";

const defaultFeatures = {
  erp_enquiry: false,
  device_status: false,
  view_holdings: false,
  erp_exceptions: false,
  kill_uploads: false,
};

const FeatureContext = createContext();

export const FeatureProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const { selectedCompany } = useCompany();
  const [features, setFeatures] = useState(defaultFeatures);

  useEffect(() => {
    if (!user) {
      setFeatures(defaultFeatures);
      return;
    }
    let cancelled = false;
    getNlisFeatures()
      .then(({ data }) => {
        if (!cancelled) setFeatures({ ...defaultFeatures, ...data.features });
      })
      .catch((err) => {
        console.error("Failed to load NLIS features:", err);
        if (!cancelled) setFeatures(defaultFeatures);
      });
    return () => {
      cancelled = true;
    };
  }, [user, selectedCompany]); // refetch on login and on company switch

  return (
    <FeatureContext.Provider value={{ features }}>
      {children}
    </FeatureContext.Provider>
  );
};

export const useFeatures = () => {
  const ctx = useContext(FeatureContext);
  if (!ctx) throw new Error("useFeatures must be used within FeatureProvider");
  return ctx;
};

export default FeatureContext;